module.exports = __webpack_public_path__ + "36017f8660fa1cdb39fb779a4392023d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-2.png
// module id = 3281
// module chunks = 0